import { render } from "./detailsImage.vue?vue&type=template&id=622cb850&scoped=true"
import script from "./detailsImage.vue?vue&type=script&lang=js"
export * from "./detailsImage.vue?vue&type=script&lang=js"

import "./detailsImage.vue?vue&type=style&index=0&id=622cb850&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622cb850"]])

export default __exports__